'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishTypingMessage = undefined;

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _TypingMessageMetadata = require('conversations-schema/records/PubNubMessageMetadata/TypingMessageMetadata');

var _TypingMessageMetadata2 = _interopRequireDefault(_TypingMessageMetadata);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var _getSenderId = require('../../selectors/pubNubMessageSelectors/getSenderId');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishTypingMessage = exports.publishTypingMessage = function publishTypingMessage(_ref) {
  var thread = _ref.thread;
  return function (dispatch, getState) {
    var channel = (0, _threadGetters.getChannel)(thread);
    var threadId = (0, _threadGetters.getThreadId)(thread);

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {
        channel: channel
      },
      metadata: (0, _TypingMessageMetadata2.default)(),
      senderId: (0, _getSenderId.getSenderId)(getState()),
      senderType: _senderTypes.VISITOR,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/actions/publishTypingMessage.js
// module id = 639
// module chunks = 2 3